import React, { useState } from 'react';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import ErrorListDisplay from '~/components/Common/ErrorListDisplay';
import Spinner from '~/components/Common/Spinner';

import { gdprRemoval } from '~/services/OrdersService';
import { getCredits } from '~/services/PaymentsService';

import { reportError } from '~/utils/reportError';

const INITIAL_STATE = {
  hasError: false,
  errors: '',
  updating: false,
  updated: false,
};

function GDPRRemovalModalContainer({
  memberId,
  email,
  currencyCode,
  brand,
  isGDPRRemovalModalVisible,
  hideGDPRRemovalModal,
}) {
  const [hasError, setHasError] = useState(false);
  const [errors, setErrors] = useState('');
  const [updating, setUpdating] = useState(false);
  const [updated, setUpdated] = useState(false);

  const resetState = () => {
    setHasError(false);
    setErrors('');
    setUpdating(false);
    setUpdated(false);
  };

  const hideModal = () => {
    resetState();
    hideGDPRRemovalModal();
  };

  const gdprRemovalAction = async () => {
    setUpdating(true);
    const credits = await getCredits(memberId, currencyCode, brand, 1);
    try {
      if (Number(credits.result.available_credit) > 0) {
        throw new Error(
          `Unable to proceed. All active credit must first be removed. Currently ${credits.result.available_credit} ${currencyCode} credits`,
        );
      }
      await gdprRemoval(memberId, { oldEmail: email });
      setUpdated(true);
    } catch (error) {
      setHasError(true);
      setErrors(error.errors || [error.message || 'Some Error Occurred']);
      reportError(error);
    }
    setUpdating(false);
  };

  return (
    <div className="container">
      <Dialog open={isGDPRRemovalModalVisible} onClose={hideModal}>
        <DialogTitle>GDPR removal</DialogTitle>

        <DialogContent>
          <p>
            This will remove all identifying information from the customer's account and from our databases. This is a
            permanent action, and should only be done with written request from the customer. Are you sure you want to
            continue?
          </p>

          {hasError && <ErrorListDisplay messages={errors} />}

          {updated && (
            <Alert severity="success">
              <p>
                All identifying information for this user is being removed. This may take several seconds. Please reload
                the page shortly.
              </p>
            </Alert>
          )}
        </DialogContent>

        <DialogActions>
          <Button variant="text" onClick={hideModal} disabled={updating}>
            Close
          </Button>
          {!updated && (
            <Button variant="contained" onClick={gdprRemovalAction} disabled={updating}>
              Remove {updating && <Spinner size={15} inline />}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default GDPRRemovalModalContainer;
